import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";
import { supabase } from "@/integrations/supabase/client";

export const adminUpdatePassword = createServerFn({ method: "POST" })
  .inputValidator((data: any) => z.object({
    userId: z.string(),
    novaSenha: z.string().min(8)
  }).parse(data))
  .handler(async ({ data, context }) => {
    // 1. Verify admin role
    const authHeader = (context as any)?.headers?.get("Authorization");
    if (!authHeader) {
      console.error("[adminUpdatePassword] No Authorization header");
      throw new Error("token ausente");
    }

    const token = authHeader.replace("Bearer ", "");
    
    // Create a client with the user's token to verify identity
    const { data: { user }, error: authError } = await supabase.auth.getUser(token);
    if (authError || !user) {
      console.error("[adminUpdatePassword] auth.getUser error:", authError);
      throw new Error("token inválido ou expirado");
    }

    // Check if user is super_admin in profiles
    const { data: profile, error: profileError } = await supabaseAdmin
      .from("profiles")
      .select("role")
      .eq("id", user.id)
      .single();

    if (profileError || !profile) {
      console.error("[adminUpdatePassword] Profile fetch error:", profileError);
      throw new Error("erro ao consultar perfil do administrador");
    }

    if (profile.role !== "super_admin") {
      console.error(`[adminUpdatePassword] User ${user.id} is not super_admin (role: ${profile.role})`);
      throw new Error("usuário não é super_admin");
    }

    // 2. Reset password using admin privileges (supabaseAdmin uses service_role)
    const { error: resetError } = await supabaseAdmin.auth.admin.updateUserById(data.userId, {
      password: data.novaSenha
    });

    if (resetError) {
      console.error("[adminUpdatePassword] auth.admin.updateUserById error:", resetError);
      throw resetError;
    }

    return { success: true };
  });
